angular.module('admin').value('vindiPaymentTypes', [
    { id: 'bank_slip', label: 'Boleto'},
    { id: 'credit_card', label: 'Cartão de Crédito'},
    { id: 'deposit', label: 'Depósito'},
    {id: 'cash', label: 'Dinheiro'}
])